import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { onClickProp, widthProp, flexProp, spacingExtraLarge, spacingMedium, maxSizeDesktop } from 'helpers/style';

import { Flex } from 'lib/components/Flex';

export const ChartHeader = styled(Flex)`
    background-color: ${(p) => p.theme.color.gray3};
    width: ${(p) => p.chartWidth}px;
`;

export const RowHeaderBase = styled(Flex)`
    ${(p) =>
        !p.hideDivider &&
        css`
            border-right: 1px solid ${p.theme.color.grayLight3};
        `};

    padding: ${spacingExtraLarge};
    ${maxSizeDesktop} {
        padding: ${spacingMedium};
    }

    padding-right: 0;
    min-width: ${(props) => props.width}px;
    color: white;
`;

export const ChartRow = styled(Flex)`
    padding-left: ${spacingExtraLarge};
    padding-right: ${spacingExtraLarge};
    ${maxSizeDesktop} {
        padding-left: ${spacingMedium};
        padding-right: ${spacingMedium};
    }
    height: 100%;
    align-items: center;
    ${onClickProp};
`;

export const RowItem = styled(Flex)`
    min-width: 13px;
    text-align: left;
    color: white;
    ${widthProp};
    ${flexProp};
    ${onClickProp};
`;
